/* Mushy · Produkt-Hero
   Zwei Custom Elements: die Galerie und der Variantenwaehler.
   Beide arbeiten ohne Abhaengigkeit zu Dawns JS. */

if (!customElements.get('mu-gallery')) {
  customElements.define(
    'mu-gallery',
    class MuGallery extends HTMLElement {
      connectedCallback() {
        // Die Buehne schiebt ueber mu-rail; hier nur Thumbs und Buehne
        // zusammenhalten.
        this.rail = this.querySelector('.mu-gallery__rail');
        this.thumbsTrack = this.querySelector('.mu-gallery__thumbs');
        this.thumbs = this.querySelectorAll('.mu-gallery__thumb');
        if (!this.rail) return;

        // Siegel und BIO-Badge gehoeren zum ersten Bild. Ab Bild 2 blenden
        // sie aus, sonst liegen sie ueber Inhalten, zu denen sie nichts
        // sagen. Der Thumb-Streifen ist eine eigene Spur, deshalb wird hier
        // nur auf die Buehne gehoert.
        this.slides = Array.from(this.querySelectorAll('.mu-gallery__image'));
        this.preload(0);

        this.rail.addEventListener('mu:rail-change', (e) => {
          const i = Number(e.detail.index);
          this.classList.toggle('is-past-first', i > 0);
          this.preload(i);
        });

        if (this.thumbs.length < 2) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            if (typeof this.rail.go === 'function') this.rail.go(Number(thumb.dataset.index));
          });
        });

        this.rail.addEventListener('mu:rail-change', (e) => this.mark(e.detail.index));
      }

      // Nachbarn scharf machen: lazy laedt erst, wenn der Slide schon
      // sichtbar ist — beim Wischen nach vorn sieht man dann kurz die leere
      // Buehne. Zwei voraus, einer zurueck reicht fuer jedes Tempo.
      preload(i) {
        if (!this.slides) return;
        [i - 1, i + 1, i + 2].forEach((n) => {
          const img = this.slides[n];
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }

      mark(i) {
        this.thumbs.forEach((thumb, n) => thumb.classList.toggle('is-active', n === i));
        // Den aktiven Thumb in die Leiste holen, ohne die Seite zu bewegen.
        const t = this.thumbs[i];
        if (!t || !this.thumbsTrack) return;
        const left = t.offsetLeft - this.thumbsTrack.offsetLeft;
        const right = left + t.offsetWidth;
        const view = this.thumbsTrack.clientWidth;
        const x = this.thumbsTrack.scrollLeft;
        if (left < x) this.thumbsTrack.scrollTo({ left, behavior: 'smooth' });
        else if (right > x + view) this.thumbsTrack.scrollTo({ left: right - view, behavior: 'smooth' });
      }
    }
  );
}

if (!customElements.get('mu-variant-picker')) {
  customElements.define(
    'mu-variant-picker',
    class MuVariantPicker extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-variants]');
        if (!data) return;

        try {
          this.variants = JSON.parse(data.textContent);
        } catch (e) {
          return;
        }

        // Auf der PDP stehen drei Produktbloecke mit je eigenem Formular.
        // Deshalb nur im eigenen Block suchen, nie ueber document — sonst
        // schreibt jeder Waehler in das erste Formular der Seite.
        this.scope = this.closest('.mu-buybox') || this.parentElement;

        this.addEventListener('change', () => this.onChange());
        this.paintPills();
      }

      get selectedOptions() {
        // Ein Radio pro Optionsgruppe, sortiert nach Position im Produkt.
        return Array.from(this.querySelectorAll('input[type="radio"]:checked'))
          .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
          .map((input) => input.value);
      }

      onChange() {
        this.paintPills();

        const chosen = this.selectedOptions;
        const variant = this.variants.find((v) =>
          chosen.every((value, i) => v.options[i] === value)
        );

        // Keine passende Kombination: Formular sperren statt eine falsche
        // Variante in den Warenkorb zu legen.
        const input = this.scope.querySelector('[data-variant-input]');
        const cta = this.scope.querySelector('.mu-buy-form .mu-cta');

        if (!variant) {
          if (cta) cta.disabled = true;
          return;
        }

        if (input) input.value = variant.id;

        // Kein Abo-Plan mehr (22.09.2026): das Formular traegt kein
        // selling_plan-Feld, der Variantenwechsel hat nichts nachzufuehren.
        if (cta) cta.disabled = !variant.available;

        this.dispatchEvent(
          new CustomEvent('mu:variant-change', { bubbles: true, detail: { variant } })
        );

        // URL mitfuehren, damit Reload und Teilen die Auswahl behalten
        if (this.dataset.url) {
          const url = new URL(window.location);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      paintPills() {
        this.querySelectorAll('.mu-pill').forEach((pill) => {
          const input = pill.querySelector('input');
          pill.classList.toggle('is-active', input && input.checked);
        });
      }
    }
  );
}

/* Bundle-Wechsel ohne Seitenneuaufbau.
   Die drei Bundles sind eigene Produkte. Statt zu navigieren holt sich das
   Element nur diese eine Section vom Ziel-Produkt (Section Rendering API)
   und tauscht sie aus. Beim Ueberfahren wird schon vorgeladen, damit der
   Klick sofort sitzt. Faellt etwas aus, greift der normale Link. */

if (!window.muSectionCache) window.muSectionCache = new Map();

if (!customElements.get('mu-bundle-switch')) {
  customElements.define(
    'mu-bundle-switch',
    class MuBundleSwitch extends HTMLElement {
      connectedCallback() {
        this.section = this.dataset.section;
        if (!this.section || !window.history.pushState || !window.DOMParser) return;

        this.addEventListener('click', (e) => this.onClick(e));

        // Vorladen, sobald die Maus oder der Finger die Pill beruehrt.
        this.querySelectorAll('a.mu-pill--bundle').forEach((link) => {
          const warm = () => this.load(link.href).catch(() => {});
          link.addEventListener('pointerenter', warm, { once: true, passive: true });
          link.addEventListener('touchstart', warm, { once: true, passive: true });
        });

        if (!MuBundleSwitch.popstateBound) {
          MuBundleSwitch.popstateBound = true;
          window.addEventListener('popstate', (e) => {
            if (!e.state || !e.state.muBundle) return;
            const el = document.querySelector('mu-bundle-switch');
            if (el) el.swap(window.location.href, true);
            else window.location.reload();
          });
        }
      }

      onClick(e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const link = e.target.closest('a.mu-pill--bundle');
        if (!link) return;

        e.preventDefault();
        // Auf das schon gewaehlte Bundle klicken tut nichts.
        if (link.classList.contains('is-active')) return;
        this.swap(link.href, false);
      }

      // Section-HTML des Zielprodukts holen, einmal pro URL.
      load(href) {
        const clean = href.split('#')[0];
        const url = clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(this.section);
        if (!window.muSectionCache.has(url)) {
          const req = fetch(url)
            .then((r) => {
              if (!r.ok) throw new Error(r.status);
              return r.text();
            })
            .catch((err) => {
              window.muSectionCache.delete(url);
              throw err;
            });
          window.muSectionCache.set(url, req);
        }
        return window.muSectionCache.get(url);
      }

      swap(href, isBack) {
        const host = document.getElementById('shopify-section-' + this.section);
        if (!host) {
          window.location.href = href;
          return;
        }

        // Der Schleier kommt erst nach 140ms — bei vorgeladenem Ziel
        // sieht man ihn gar nicht.
        const veil = window.setTimeout(() => host.classList.add('is-swapping'), 140);

        this.load(href)
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.getElementById('shopify-section-' + this.section);
            const markup = next ? next.innerHTML : doc.body.innerHTML;
            if (!markup.trim()) throw new Error('leer');

            if (!isBack) {
              if (!window.history.state || !window.history.state.muBundle) {
                window.history.replaceState({ muBundle: window.location.href }, '', window.location.href);
              }
              window.history.pushState({ muBundle: href }, '', href);
            }

            host.innerHTML = markup;
            window.clearTimeout(veil);
            host.classList.remove('is-swapping');

            // Der Tab-Titel blieb auf dem alten Bundle stehen: wir tauschen
            // nur die Section, den Titel liefert Shopify dabei nicht mit.
            const name = host.querySelector('.mu-buybox__title');
            if (name && name.textContent.trim()) {
              const shop = document.title.split('\u2013').pop().trim();
              document.title = name.textContent.trim() + (shop ? ' \u2013 ' + shop : '');
            }

            document.dispatchEvent(
              new CustomEvent('mu:bundle-change', { detail: { url: href } })
            );
          })
          .catch(() => {
            window.clearTimeout(veil);
            host.classList.remove('is-swapping');
            window.location.href = href;
          });
      }
    }
  );
}

/* Staffel-Wechsel (1 Beutel, 2 + 1 gratis, 3 + 2 gratis).
   Die drei Pills sind Varianten eines Angebotsprodukts. Alle drei Staende
   liegen schon im Markup (.mu-pane), der Wechsel tauscht Sichtbarkeit,
   Preiszeile, Formularwerte und die Sticky-Leiste. Kein Netz, kein Neuladen. */

if (!customElements.get('mu-bundle-panes')) {
  customElements.define(
    'mu-bundle-panes',
    class MuBundlePanes extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section') || document;
        this.addEventListener('click', (e) => {
          const pill = e.target.closest('[data-pane-pill]');
          if (pill && !pill.classList.contains('is-active')) this.select(pill);
        });
      }

      select(pill) {
        const n = pill.dataset.panePill;
        const root = this.root;
        const d = pill.dataset;

        this.querySelectorAll('[data-pane-pill]').forEach((p) => {
          const on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        root.querySelectorAll('.mu-pane[data-pane]').forEach((el) => {
          el.hidden = el.dataset.pane !== n;
        });

        const form = root.querySelector('#mu-product-hero-form');
        if (form) {
          const set = (sel, value) => {
            const el = form.querySelector(sel);
            if (el) el.value = value;
          };
          set('[data-variant-input]', d.variant);
          set('[data-free-id]', d.freeId || '');
          set('[data-free-qty]', d.freeQty || '0');
          const cta = form.querySelector('.mu-cta');
          if (cta) cta.disabled = d.available !== 'true';
        }

        // Preiszeile der Buy-Box. Leerer Wert blendet das Element aus
        // (z. B. kein Streichpreis).
        const text = (sel, value) => {
          root.querySelectorAll(sel).forEach((el) => {
            el.textContent = value || '';
            el.hidden = !value;
          });
        };
        text('.mu-buybox-footer .mu-price__now', d.now);
        text('.mu-buybox-footer .mu-price__was', d.was);
        text('.mu-buybox-footer .mu-price__badge', d.badge);
        text('.mu-buybox-footer .mu-price__serving', d.serving);

        root.querySelectorAll('[data-pane-row]').forEach((row) => {
          const on = row.dataset.paneRow === n;
          row.classList.toggle('is-active', on);
          if (on) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
        const label = root.querySelector('.mu-sticky__toggle > span');
        if (label) label.textContent = d.label;
        const price = root.querySelector('.mu-sticky__price');
        if (price) price.textContent = d.now;

        // Bundle-Bild vorn in der Galerie tauschen und dorthin springen.
        if (d.img) {
          const slide = root.querySelector('[data-bundle-slide]');
          if (slide) {
            slide.srcset = d.imgSrcset || '';
            slide.src = d.img;
            slide.alt = d.imgAlt || '';
          }
          const thumb = root.querySelector('[data-bundle-thumb]');
          if (thumb && d.imgThumb) thumb.src = d.imgThumb;
          const rail = root.querySelector('.mu-gallery__rail');
          if (rail && typeof rail.go === 'function') rail.go(0);
        }

        document.dispatchEvent(new CustomEvent('mu:bundle-change', { detail: { pane: n } }));
      }
    }
  );
}
